/**
 * @desc 确认修改密码
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** 用户编码 */
  code: string;
  /** 修改密码 */
  password: string;
}

export function request(params: Params): Promise<defs.StandardReturn<string>> {
  return defHttp.get({
    url: '/web/user/updatePwd',

    params,
  });
}

export function mock(params: Params): Promise<defs.StandardReturn<string>> {
  return defHttp.get({
    url: '/mock/web/user/updatePwd',

    params,
  });
}
